module.exports = __webpack_public_path__ + "static/media/WDI2_Logo.dbcc482a.png";